import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

function About({ onOpenAuth, onOpenMenu }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-white to-pink-50 text-slate-900 flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto flex w-full max-w-7xl flex-1 items-stretch px-4 py-6 md:px-6 md:py-8">
        <section className="flex w-full min-h-full items-center rounded-3xl border border-purple-100 bg-white p-6 shadow-lg md:p-10">
          <div className="mx-auto grid w-full max-w-6xl items-start gap-8 md:grid-cols-[200px_1fr]">
            <img
              src="https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=500&q=80"
              alt="Team working together"
              className="h-36 w-full rounded-2xl object-cover md:h-44"
            />

            <div>
              <h1 className="text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">About Us</h1>
              <p className="mt-4 text-sm leading-relaxed text-slate-600 md:text-base">
                Femtyz is your everyday shopping companion, designed for people who want clarity before
                they buy. Instead of opening multiple apps and tabs, you get a single place where
                product options, platform-wise availability, and useful comparisons are presented in a
                simple, understandable format.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">
                We started with one idea: shopping should feel confident, not confusing. Many users
                spend too much time searching for the same item across different stores, trying to
                understand which option is better in value, quality, or convenience. Femtyz reduces
                this effort by organizing product details so decisions can be made faster and with less
                stress.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">
                On Femtyz, you can discover top deals, browse by platform, and explore products based
                on useful features that matter in real life. Whether you are buying daily essentials,
                trying a new brand, or planning a bigger purchase, our layout helps you scan key
                information quickly and stay focused on what fits your needs.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">
                Our mission is to make product discovery transparent. We believe users should know what
                they are choosing, why they are choosing it, and how it compares to alternatives. That
                is why we prioritize clean presentation, readable content, and consistent navigation
                across the application.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">
                Behind Femtyz is a team focused on continuous improvement. We regularly refine search
                experience, category coverage, and content quality so the platform becomes more helpful
                over time. Every update is guided by one principle: save user time while improving
                decision quality.
              </p>
      
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
